import React, { useState } from 'react';
import { useCustomContext } from '../CustomComponents/CustomComponents';
import './Users.css';
import { FaEdit } from "react-icons/fa";
import { UsersLogic } from './UsersLogic';
import { GoLaw } from 'react-icons/go';
import { FcGoogle } from "react-icons/fc";
import { MdCancel } from "react-icons/md";
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa6';
import ProjectAccessModal from './ProjectAccessModal/ProjectAccessModal';

const Users = () => {
  const {
    datasets,
    paginatedUsers,
    totalPages,
    totalRecords,
    startEntry,
    endEntry,
    pageSize,
    setPageSize,
    searchEmail,
    setSearchEmail,
    currentPage,
    setCurrentPage,
    // handleProjectAccessSave,
    handleToggleEmployeeActive,
    handleAccessLevelChange,
    fetchUsers,
    /*change Password*/
    showPasswordModal,
    passwordForm,
    passwordErrors,
    showNewPassword,
    showConfirmPassword,
    setPasswordForm,
    setPasswordErrors,
    setShowNewPassword,
    setShowConfirmPassword,
    openChangePasswordModal,
    closeChangePasswordModal,
    handleSavePassword
  } = UsersLogic();

  // Modal State
  const [showProjectModal, setShowProjectModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isAddMode, setIsAddMode] = useState(false);
  const { showAlert } = useCustomContext();

  const handleEditProjectAccess = (user) => {
    setSelectedUser(user);
    setIsAddMode(false);
    setShowProjectModal(true);
  };

  const closeProjectModal = () => {
    setSelectedUser(null);
    setIsAddMode(false);
    setShowProjectModal(false);
  };
  return (
    <div className="main-content">
      <div className="p-3 mb-0 mt-1 custom-bg-white rounded d-flex justify-content-between align-items-center">
        <span className="m-0 title">Users</span>

        <button
          className="add-btn btn-sm btn-primary"
          onClick={() => {
            setSelectedUser(null);
            setIsAddMode(true);      // add mode
            setShowProjectModal(true);
          }}
        >
          + Add New User
        </button>
      </div>

      <div className="mt-3">
        <div className="users-toolbar mb-3" autoComplete="off" >
          <input type="text" name="fake-user" style={{ display: "none" }} />
          {/* SEARCH */}
          <input
            type="text"
            name="user_search_field"   // ❗ avoid "email"
            autoComplete="off"
            className="form-control users-search"
            placeholder="Search by email"
            value={searchEmail}
            onChange={(e) => setSearchEmail(e.target.value)}

          />

          {/* SHOWING TEXT */}
          <span className="users-showing">
            Showing {startEntry} to {endEntry} of {totalRecords} entries
          </span>

          {/* PAGE SIZE */}
          <div className="users-pagesize">
            <span>Show</span>
            <select
              className="form-select"
              value={pageSize}
              onChange={(e) => {
                setPageSize(Number(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
          </div>

          {/* PAGINATION */}
          <ul className="pagination-req users-pagination">
            <li>
              <button
                className="page-btn-req"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(p => p - 1)}
              >
                &lt;
              </button>
            </li>

            <li>
              <button className="page-btn-req page-btn-active">
                {currentPage}
              </button>
            </li>

            <li>
              <button
                className="page-btn-req"
                disabled={currentPage === totalPages || totalPages === 0}
                onClick={() => setCurrentPage(p => p + 1)}
              >
                &gt;
              </button>
            </li>
          </ul>

        </div>


        <div className='table-content-user '>
          <table className="user-table">
            <thead >
              <tr>
                <th>Email</th>
                <th className="text-center">Actions</th>
              </tr>
            </thead>

            <tbody>
              {paginatedUsers.map((user) => {
                const email = user.email;
                const isEmployeeActive = user.isEmployeeActive;
                return (
                  <tr key={user.Username}>
                    {/* EMAIL */}
                    <td className="user-email">{email}</td>

                    {/* ACTIONS */}
                    <td>
                      <div className="action-btn-group">
                        <button
                          className="btn action-btn edit-btn"
                          onClick={() => handleEditProjectAccess(user)}
                        >
                          Edit User
                        </button>
                        {isEmployeeActive ? (
                          <button
                            className="btn action-btn delete-btn"
                            onClick={() => {
                              showAlert(
                                "Are you sure you want to disable this user?",
                                [
                                  {
                                    label: "Cancel",
                                    onClick: () => { },
                                    color: "#6c757d"
                                  },
                                  {
                                    label: "Disable",
                                    onClick: () =>
                                      handleToggleEmployeeActive(user.Username, false),
                                    color: "var(--buttonColor)"
                                  }
                                ]
                              );
                            }}
                          >
                            Disable User
                          </button>
                        ) : (
                          <button
                            className="btn action-btn enable-btn"
                            onClick={() => {
                              showAlert(
                                "Are you sure you want to enable this user?",
                                [
                                  {
                                    label: "Cancel",
                                    onClick: () => { },
                                    color: "#6c757d"
                                  },
                                  {
                                    label: "Enable",
                                    onClick: () =>
                                      handleToggleEmployeeActive(user.Username, true),
                                    color: "var(--buttonColor)"
                                  }
                                ]
                              );
                            }}>
                            Enable User
                          </button>
                        )}
                        <button
                          className="btn action-btn password-btn"
                          onClick={() => openChangePasswordModal(user)}
                        >
                          Change Password
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

        </div>
      </div>

      {/* PROJECT ACCESS MODAL */}
      {showProjectModal && (
        <ProjectAccessModal
          user={isAddMode ? null : selectedUser}
          datasets={datasets}
          onClose={closeProjectModal}
          // onSaveProjectAccess={handleProjectAccessSave}
          usersList={async () => { await fetchUsers(); }}
        />
      )}
      {/*change Password MODAL */}
      {showPasswordModal && (
        <div className="cp-modal-overlay">
          <div className="cp-modal">

            {/* HEADER */}
            <div className="cp-modal-header">
              <span className="cp-modal-title">Change Password</span>
              <MdCancel
                className="cp-modal-close"
                onClick={closeChangePasswordModal}
              />
            </div>

            {/* BODY */}
            <form autoComplete="off">
              {/* Fake hidden fields */}
              <input
                type="text"
                name="fake_username"
                autoComplete="username"
                style={{ display: "none" }}
              />

              <input
                type="password"
                name="fake_password"
                autoComplete="current-password"
                style={{ display: "none" }}
              />

              <div className="cp-modal-body">
                {/* NEW PASSWORD */}
                <div className="cp-field">
                  <label className="cp-label">
                    New Password <span style={{ color: "red" }}>*</span>
                  </label>

                  <div className="cp-password-wrapper">
                    <input
                      type={showNewPassword ? "text" : "password"}
                      className={`form-control cp-input ${passwordErrors.newPassword ? "is-invalid" : ""
                        }`}
                      value={passwordForm.newPassword}

                      // IMPORTANT
                      name={`np_${Date.now()}`}
                      autoComplete="new-password"
                      data-lpignore="true"
                      data-form-type="other"

                      onChange={(e) => {
                        setPasswordForm({
                          ...passwordForm,
                          newPassword: e.target.value
                        });

                        setPasswordErrors({
                          ...passwordErrors,
                          newPassword: ""
                        });
                      }}
                    />

                    <span
                      className={`cp-eye-icon ${passwordErrors.newPassword ? "has-error" : ""
                        }`}
                      onClick={() => setShowNewPassword(!showNewPassword)}
                    >
                      {showNewPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                    </span>
                  </div>
                  {passwordErrors.newPassword && (
                    <div className="invalid-feedback d-block">
                      {passwordErrors.newPassword}
                    </div>
                  )}
                </div>

                {/* CONFIRM PASSWORD */}
                <div className="cp-field">
                  <label className="cp-label">
                    Confirm Password <span style={{ color: "red" }}>*</span>
                  </label>

                  <div className="cp-password-wrapper">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      className={`form-control cp-input ${passwordErrors.confirmPassword ? "is-invalid" : ""
                        }`}
                      value={passwordForm.confirmPassword}

                      // IMPORTANT
                      name={`cp_${Date.now()}`}
                      autoComplete="new-password"
                      data-lpignore="true"
                      data-form-type="other"

                      onChange={(e) => {
                        setPasswordForm({
                          ...passwordForm,
                          confirmPassword: e.target.value
                        });

                        setPasswordErrors({
                          ...passwordErrors,
                          confirmPassword: ""
                        });
                      }}
                    />

                    <span
                      className={`cp-eye-icon ${passwordErrors.confirmPassword ? "has-error" : ""
                        }`}
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                    >
                      {showConfirmPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                    </span>
                  </div>
                  {passwordErrors.confirmPassword && (
                    <div className="invalid-feedback d-block">
                      {passwordErrors.confirmPassword}
                    </div>
                  )}
                </div>
              </div>
            </form>

            {/* FOOTER */}
            <div className="cp-modal-footer">
              <button
                className="cp-save-btn"
                onClick={handleSavePassword}
              >
                Save
              </button>
            </div>

          </div>
        </div>
      )}

    </div >
  );
};

export default Users;
